import { useI18n } from "@/i18n/I18nProvider";

export default function Imprint() {
  const { t } = useI18n();
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('legal.imprint.title', 'Imprint / Legal Notice')}</h1>
      <div className="space-y-2 text-gray-700">
        <div><span className="font-semibold">{t('legal.imprint.operator', 'Operator')}:</span> Alessandro Vendramin</div>
        <div><span className="font-semibold">{t('legal.imprint.address', 'Address')}:</span> Via Cavetta Marina, 55, Jesolo (VE), Italy</div>
        <div><span className="font-semibold">{t('legal.imprint.email', 'Email')}:</span> <a className="underline" href="mailto:alessandro@halomora.com">alessandro@halomora.com</a></div>
        <div><span className="font-semibold">{t('legal.imprint.website', 'Website')}:</span> halomora.com</div>
        <div><span className="font-semibold">{t('legal.imprint.vat', 'VAT / Tax ID')}:</span> {t('legal.imprint.vat_value', '(if applicable)')}</div>
      </div>
      <p className="text-sm text-gray-500 mt-6">
        {t('legal.imprint.note', 'This site is a marketplace that connects customers with independent vendors. Services are provided by the respective vendors. For information about data processing, see our')}{" "}
        <a className="underline" href="/legal/privacy">{t('legal.imprint.privacy_link', 'Privacy Policy')}</a>.
      </p>
    </div>
  );
}
